import { CHANGE_FILTER, CHANGE_DATALIST, CHANGE_MUTEX, CHANGE_VALUES, SET_INITIAL_STATE, SET_NEW_URL_STATE, CHANGE_MARCA, RESET_APPLICATION } from "./actionTypes";

export function changeFilter(name, value) {
  return { type: CHANGE_FILTER, name, value }
}

export function changeDatalist(name, value) {
  return { type: CHANGE_DATALIST, name, value }
}

export function changeMutex(name, value) {
  return { type: CHANGE_MUTEX, name, value }
}

export function changeValues(value) {
  return { type: CHANGE_VALUES, value }
}

export function setInitialState(value) {
  return { type: SET_INITIAL_STATE, value }
}

export function setNewUrlState(value) {
  return { type: SET_NEW_URL_STATE, value }
}

export function changeMarca(value) {
  return { type: CHANGE_MARCA, value }
}

export function resetApplication(value) {
  return { type: RESET_APPLICATION, value }
}
